// @ts-nocheck
import { CREATE_ENGAGEMENT_ERROR, CREATE_ENGAGEMENT_LOADING, CREATE_ENGAGEMENT_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const create_product_engagement = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: CREATE_ENGAGEMENT_LOADING,
                data: true
            })
            Authservices.create_product_engagement(data).then((data) => {
                if (data?.status === 200) {
                    dispatch({
                        type: CREATE_ENGAGEMENT_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: CREATE_ENGAGEMENT_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}
